export const plans = [
  {
    name: 'Starter',
    tickets: 8,
    prices: {
      usd: 36,
      jpy: 3600,
      ntd: 990,
    },
  },
  {
    name: 'Regular',
    tickets: 16,
    prices: {
      usd: 56,
      jpy: 5600,
      ntd: 1590,
    },
  },
  {
    name: 'Plus',
    tickets: 32,
    prices: {
      usd: 106,
      jpy: 10600,
      ntd: 2990,
    },
  },
  {
    name: 'Premium',
    tickets: 48,
    prices: {
      usd: 149,
      jpy: 14900,
      ntd: 4290,
    },
  },
];
